module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAATCAYAAAHuYL1ZAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAMVJREFUeNpiZGBgMADiAAYo+M8EYwEEECMQN8A4CQzIACCAMBAz1IgbIBOA+CFAAKFoxgv+QzGcg40NAQABxIjuWEIgAasxaBL/0RUaYHEhDDjg8gIcAAQQIZ9/YGKgNgDZP59Q+GJVBBPcD/UaXBELlLMAiBOhCmC+A3sX5ItCqCS2eLqILrgfPfQIhgNAgMF0/acA0xaA/FNAjsYELE6dT6rG+UjhM5+QQQk4FMAMcMCnbj8ek9ENwGYhUVHsgEsBxRkGABSLUUxeAD+ZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homepage/backtohead.png
// module id = Znw1
// module chunks = 1